<template>
  <svg width="2em" height="2em" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10.668 2H14.0013V5.33333" stroke="#0144C7" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M2.66797 13.3333L14.0013 2" stroke="#0144C7" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M14.0013 10.667V14.0003H10.668" stroke="#0144C7" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M10 10L14 14" stroke="#0144C7" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M2.66797 2.66699L6.0013 6.00033" stroke="#0144C7" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>